"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubjectInfoArrayEqual = exports.SubjectInfoJSONSchema = void 0;
const zod_1 = require("zod");
exports.SubjectInfoJSONSchema = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string().optional()
});
// eslint-disable-next-line require-jsdoc
function isSubjectInfoArrayEqual(objValue, othValue) {
    if (objValue.length != othValue.length) {
        return false;
    }
    for (let i = 0; i < objValue.length; i++) {
        if (objValue[i].id != othValue[i].id && objValue[i].title != othValue[i].title) {
            return false;
        }
    }
    return true;
}
exports.isSubjectInfoArrayEqual = isSubjectInfoArrayEqual;
